// Mounts the deck in an iframe. This iframe IS the source of truth — the
// sync-plugin running inside it publishes slide events as we navigate.
// We capture global keyboard input and forward to its Reveal instance.

const SLIDE_W = 1920;
const SLIDE_H = 1080;

function fit(host, iframe) {
  const r = host.getBoundingClientRect();
  const scale = Math.min(r.width / SLIDE_W, r.height / SLIDE_H);
  iframe.style.transform = `scale(${scale})`;
  // Center the scaled iframe in the host.
  const offsetX = (r.width  - SLIDE_W * scale) / 2;
  const offsetY = (r.height - SLIDE_H * scale) / 2;
  iframe.style.left = offsetX + 'px';
  iframe.style.top  = offsetY + 'px';
}

export default {
  id:   'slide-preview',
  slot: 'current-slide',
  mount({ slot, deck, session, deckId }) {
    slot.innerHTML = `
      <div class="panel-header"><span>Current slide</span><span data-role="position"></span></div>
      <div class="panel-body"><div class="slide-frame-host"><iframe data-role="frame"></iframe></div></div>
    `;
    const host  = slot.querySelector('.slide-frame-host');
    const frame = slot.querySelector('iframe');
    const pos   = slot.querySelector('[data-role="position"]');

    frame.src = `/decks/${encodeURIComponent(deckId)}/?session=${encodeURIComponent(session)}&role=speaker`;

    deck.bind(frame, () => {
      fit(host, frame);
      const update = () => {
        const i = deck.getIndices();
        const total = deck.reveal.getHorizontalSlides?.()?.length ?? 0;
        let s = `${i.h + 1}/${total}`;
        if ((i.v ?? 0) > 0) s += ` · ${i.v + 1}`;
        pos.textContent = s;
      };
      update();
      deck.reveal.on('slidechanged',   update);
      deck.reveal.on('fragmentshown',  update);
      deck.reveal.on('fragmenthidden', update);
    });

    new ResizeObserver(() => fit(host, frame)).observe(host);
  },
};
